import React from 'react';
import { useNavigate } from 'react-router-dom';

const BuildingSection = () => {
  const navigate = useNavigate();
    return (
        <div>
        <div
        className="bg-cover bg-center py-16 text-center text-black"
      >
        <div className="container mx-auto px-4">
          <h1 className="text-4xl font-semibold mb-4">Start Building Smarter Documents with Zynth.ai </h1>
          <p className="text-lg mb-8 font-semibold">
            Stop wasting hours on manual drafting. Let AI structure, polish, and refine your documents—all in one platform. 
          </p>
          <div className="text-center mt-6">
        <button
          onClick={() => navigate('/auth')}
          className="bg-[#3667B2] text-white px-8 py-4 font-semibold rounded-lg shadow-md hover:bg-blue-700 mb-4 active:scale-95 transition transform duration-300"
        >
         Get Started Free with Zynth.ai
        </button>
      </div>
          </div>
          </div>
          </div>
    )
}

export default BuildingSection